export const bacteriaLayoutConfig_oms_eng = [
    {
        label: 'Blautia genus',
        page: 12,
        yOffset: 228,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 218,
        yResult: 218,
        yResulttext: 222,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Firmicutes phylum',
        page: 12,
        yOffset: 267,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 257,
        yResult: 257,
        yResulttext: 261,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Ruminococcus obeum',
        page: 12,
        yOffset: 306,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 296,
        yResult: 296,
        yResulttext: 300,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Akkermansia muciniphila',
        page: 12,
        yOffset: 380,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 370,
        yResult: 370,
        yResulttext: 374,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Bacteroidetes phylum',
        page: 12,
        yOffset: 419,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 409,
        yResult: 409,
        yResulttext: 413,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 12,
        yOffset: 458,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 448,
        yResult: 448,
        yResulttext: 452,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 12,
        yOffset: 531,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 521,
        yResult: 521,
        yResulttext: 525,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Lactobacillus gasseri',
        page: 12,
        yOffset: 570,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 560,
        yResult: 560,
        yResulttext: 564,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Lactobacillus paracasei',
        page: 12,
        yOffset: 609,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 599,
        yResult: 599,
        yResulttext: 603,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 12,
        yOffset: 648,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 638,
        yResult: 638,
        yResulttext: 642,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Lactobacillus reuteri',
        page: 12,
        yOffset: 687,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 677,
        yResult: 677,
        yResulttext: 681,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Blautia genus',
        page: 16,
        yOffset: 140,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 130,
        yResult: 677,
        yResulttext: 134,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Firmicutes phylum',
        page: 16,
        yOffset: 331,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 321,
        yResult: 677,
        yResulttext: 325,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Ruminococcus obeum',
        page: 16,
        yOffset: 575,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 565,
        yResult: 677,
        yResulttext: 569,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Akkermansia muciniphila',
        page: 17,
        yOffset: 140,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 130,
        yResult: 677,
        yResulttext: 134,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Bacteroidetes phylum',
        page: 17,
        yOffset: 385,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 375,
        yResult: 677,
        yResulttext: 379,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 17,
        yOffset: 684,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 674,
        yResult: 677,
        yResulttext: 678,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 18,
        yOffset: 137,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 127,
        yResult: 677,
        yResulttext: 131,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Lactobacillus gasseri',
        page: 18,
        yOffset: 555,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 545,
        yResult: 677,
        yResulttext: 549,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Lactobacillus paracasei',
        page: 19,
        yOffset: 72,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 62,
        yResult: 677,
        yResulttext: 66,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 19,
        yOffset: 290,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 280,
        yResult: 677,
        yResulttext: 284,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Lactobacillus reuteri',
        page: 19,
        yOffset: 732,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 722,
        yResult: 677,
        yResulttext: 726,
        xResulttext: 555,
        show_result: false
    },
];

export const bacteriaLayoutConfig_oms_thai = [
    {
        label: 'Blautia genus',
        page: 11,
        yOffset: 228,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 218,
        yResult: 218,
        yResulttext: 222,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Firmicutes phylum',
        page: 11,
        yOffset: 267,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 257,
        yResult: 257,
        yResulttext: 261,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Ruminococcus obeum',
        page: 11,
        yOffset: 306,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 296,
        yResult: 296,
        yResulttext: 300,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Akkermansia muciniphila',
        page: 11,
        yOffset: 380,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 370,
        yResult: 370,
        yResulttext: 374,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Bacteroidetes phylum',
        page: 11,
        yOffset: 419,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 409,
        yResult: 409,
        yResulttext: 413,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 11,
        yOffset: 458,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 448,
        yResult: 448,
        yResulttext: 452,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 11,
        yOffset: 531,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 521,
        yResult: 521,
        yResulttext: 525,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Lactobacillus gasseri',
        page: 11,
        yOffset: 570,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 560,
        yResult: 560,
        yResulttext: 564,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Lactobacillus paracasei',
        page: 11,
        yOffset: 609,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 599,
        yResult: 599,
        yResulttext: 603,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 11,
        yOffset: 648,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 638,
        yResult: 638,
        yResulttext: 642,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Lactobacillus reuteri',
        page: 11,
        yOffset: 687,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 677,
        yResult: 677,
        yResulttext: 681,
        xResulttext: 555,
        show_result: true
    },

    {
        label: 'Blautia genus',
        page: 15,
        yOffset: 143,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 133,
        yResult: 677,
        yResulttext: 137,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Firmicutes phylum',
        page: 15,
        yOffset: 300,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 290,
        yResult: 677,
        yResulttext: 294,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Ruminococcus obeum',
        page: 15,
        yOffset: 495,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 485,
        yResult: 677,
        yResulttext: 489,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Akkermansia muciniphila',
        page: 16,
        yOffset: 143,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 133,
        yResult: 677,
        yResulttext: 137,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Bacteroidetes phylum',
        page: 16,
        yOffset: 385,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 375,
        yResult: 677,
        yResulttext: 379,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 16,
        yOffset: 684,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 674,
        yResult: 677,
        yResulttext: 678,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 17,
        yOffset: 137,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 127,
        yResult: 677,
        yResulttext: 131,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Lactobacillus gasseri',
        page: 17,
        yOffset: 555,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 545,
        yResult: 677,
        yResulttext: 549,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Lactobacillus paracasei',
        page: 18,
        yOffset: 72,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 62,
        yResult: 677,
        yResulttext: 66,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 18,
        yOffset: 290,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 280,
        yResult: 677,
        yResulttext: 284,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Lactobacillus reuteri',
        page: 18,
        yOffset: 732,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 722,
        yResult: 677,
        yResulttext: 726,
        xResulttext: 555,
        show_result: false
    },
];